import React from 'react';
import { Type, Square, Circle, Minus, Trash2, Download, Image } from 'lucide-react';

export default function ToolPanel({ canvasRef, onExportHTML, onExportGIF }) {
  const addText = () => canvasRef.current?.addText('Your Text Here');
  const addRect = () => canvasRef.current?.addRect();
  const addCircle = () => canvasRef.current?.addCircle();

  const addLine = () => {
    const canvas = canvasRef.current?.getCanvas();
    if (!canvas) return;
    const { fabric } = require('fabric');
    const line = new fabric.Line([20, 80, 200, 80], {
      stroke: '#374151',
      strokeWidth: 2,
      selectable: true,
    });
    canvas.add(line);
    canvas.renderAll();
  };

  const addSocialIcon = (platform) => {
    const colors = {
      li: '#0077B5',
      tw: '#1DA1F2',
      ig: '#E1306C',
      fb: '#1877F2',
    };
    const canvas = canvasRef.current?.getCanvas();
    if (!canvas) return;
    const { fabric } = require('fabric');
    const color = colors[platform] || '#374151';
    const rect = new fabric.Rect({
      width: 28,
      height: 28,
      rx: 4,
      ry: 4,
      fill: color,
      left: 20,
      top: 20,
    });
    const labels = { li: 'in', tw: 'tw', ig: 'ig', fb: 'fb' };
    const text = new fabric.Text(labels[platform] || '?', {
      fontSize: 14,
      fill: '#ffffff',
      fontWeight: 'bold',
      fontFamily: 'Arial',
      left: 20 + 14 - 7,
      top: 20 + 14 - 8,
    });
    const group = new fabric.Group([rect, text], { left: 20, top: 20 });
    canvas.add(group);
    canvas.renderAll();
  };

  const uploadImage = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = (e) => {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (re) => {
        canvasRef.current?.addImage(re.target.result);
      };
      reader.readAsDataURL(file);
    };
    input.click();
  };

  const deleteSelected = () => canvasRef.current?.deleteSelected();

  const tools = [
    { icon: Type, label: 'Text', action: addText },
    { icon: Square, label: 'Rectangle', action: addRect },
    { icon: Circle, label: 'Circle', action: addCircle },
    { icon: Minus, label: 'Line', action: addLine },
    { icon: Image, label: 'Image', action: uploadImage },
  ];

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Elements</h3>
        <div className="grid grid-cols-2 gap-1.5">
          {tools.map(t => {
            const Icon = t.icon;
            return (
              <button
                key={t.label}
                onClick={t.action}
                className="flex items-center gap-1.5 px-2 py-2 text-xs text-gray-700 border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-colors"
              >
                <Icon className="w-3.5 h-3.5 text-gray-500" /> {t.label}
              </button>
            );
          })}
        </div>
      </div>

      <div>
        <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Social Icons</h3>
        <div className="grid grid-cols-4 gap-1">
          {[
            { key: 'li', label: 'in', color: 'text-blue-700' },
            { key: 'tw', label: 'tw', color: 'text-sky-500' },
            { key: 'ig', label: 'ig', color: 'text-pink-500' },
            { key: 'fb', label: 'fb', color: 'text-blue-600' },
          ].map(p => (
            <button
              key={p.key}
              onClick={() => addSocialIcon(p.key)}
              className={`p-2 border border-gray-200 rounded-lg hover:bg-gray-50 text-xs font-bold text-center ${p.color}`}
              title={p.key}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>

      <div className="border-t border-gray-200 pt-3 space-y-1.5">
        {onExportHTML && (
          <button
            onClick={onExportHTML}
            className="w-full flex items-center gap-2 px-3 py-2 bg-blue-600 text-white text-xs rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Download className="w-3.5 h-3.5" /> Export HTML
          </button>
        )}
        {onExportGIF && (
          <button
            onClick={onExportGIF}
            className="w-full flex items-center gap-2 px-3 py-2 bg-purple-600 text-white text-xs rounded-lg hover:bg-purple-700 transition-colors"
          >
            <Download className="w-3.5 h-3.5" /> Export GIF
          </button>
        )}
        <button
          onClick={deleteSelected}
          className="w-full flex items-center gap-2 px-3 py-2 border border-red-200 text-red-600 text-xs rounded-lg hover:bg-red-50 transition-colors"
        >
          <Trash2 className="w-3.5 h-3.5" /> Delete Selected
        </button>
      </div>
    </div>
  );
}
